/* unplugin-vue-components disabled */import { render } from "./mg-department-select.vue?vue&type=template&id=93e687e0"
import script from "./mg-department-select.vue?vue&type=script&lang=js"
export * from "./mg-department-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__